<template>
  <el-table
    :border="true"
    id="rebateSetTable"
    :data="productList"
    show-summary
    ref="table"
    :summary-method="getSummaries"
    :max-height="tableHeight"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.1)"
    class="user-table"
  >
    <el-table-column
      v-for="(item, i) in column"
      :prop="item.key"
      :label="item.name"
      :key="i"
      :width="item.width"
      :sortable="item.sort"
      :sort-method="item.sortMethod"
      align="center"
      :fixed="item.fixed"
    >
      <el-table-column :prop="item.key" :label="totalColumn[i] + ''" :key="i" align="center">
        <!-- {{ scope.row[item.key]? scope.row[item.key]:"-" }}{{scope.row[item.key]? item.unit:null}} -->
        <template slot-scope="scope">
          <span
            >{{
              scope.row[item.key] == "NaN"
                ? "-"
                : scope.row[item.key] !== "0.00" && scope.row[item.key] !== 0
                ? scope.row[item.key]
                : "-"
            }}{{
              scope.row[item.key] !== "0.00" && scope.row[item.key] !== "NaN" ? item.percent : null
            }}</span
          >
        </template>
      </el-table-column>
      <!-- <el-table-column label="a"></el-table-column> -->
    </el-table-column>
  </el-table>
</template>

<script>
import XLSX from "xlsx";
import FileSaver from "file-saver";
import { sumArr } from "../../utils/tool";

export default {
  data() {
    return {
      tableHeight: window.innerHeight - 200,
    };
  },
  // computed: {
  //   autoHeight: function() {
  //     return this.tableHeight - 1;
  //   }
  // },
  props: {
    productList: Array,
    column: Array,
    loading: Boolean,
    isisRateProps: Boolean,
    totalColumn: Array,
  },
  methods: {
    downLoadFileToExcel() {
      let fix = document.querySelector(".el-table__fixed");
      var xlsxParam = { raw: true }; //导出的内容只做解析，不进行格式转换(添加此行代码表格中的百分比就不会再导出的时候被转换成小数点)
      let wb;
      if (fix) {
        //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
        wb = XLSX.utils.table_to_book(
          document.querySelector("#rebateSetTable").removeChild(fix),
          xlsxParam
        );
        document.querySelector("#rebateSetTable").appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(document.querySelector("#rebateSetTable"), xlsxParam);
      }
      let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), "用户报表.xlsx");
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        // const summary = this.$store.state.UserManage.purByCountrySummary;
        let currentItem = this.column.filter((v) => v.key == column.property);
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value)) && !currentItem[0].unit) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr) ? Number(curr) : 0;
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          currentItem[0].unit ? (sums[index] += " %") : sums[index];
        } else {
          sums[index] = "-";
        }
      });
      const retenRate1 = data.map((item) => Number(item["retention1"]));
      const retenRate3 = data.map((item) => Number(item["retention3"]));
      const retenRate7 = data.map((item) => Number(item["retention7"]));
      const retenRate14 = data.map((item) => Number(item["retention14"]));
      const retenRate30 = data.map((item) => Number(item["retention30"]));
      // const totalIncre = data.map(item => Number(item["totalIncre"]));
      let totalIncre1 = data.map((item) => Number(item["totalInstalls1"])),
        totalIncre3 = data.map((item) => Number(item["totalInstalls3"])),
        totalIncre7 = data.map((item) => Number(item["totalInstalls7"])),
        totalIncre14 = data.map((item) => Number(item["totalInstalls14"])),
        totalIncre30 = data.map((item) => Number(item["totalInstalls30"]));
      let retenRate1Total = sumArr(retenRate1);
      let retenRate3Total = sumArr(retenRate3);
      let retenRate7Total = sumArr(retenRate7);
      let retenRate14Total = sumArr(retenRate14);
      let retenRate30Total = sumArr(retenRate30);
      if (this.isisRateProps) {
        sums[5] =
          isNaN(retenRate1Total) || retenRate1Total == 0 || sumArr(totalIncre1) == 0
            ? "-"
            : ((retenRate1Total / sumArr(totalIncre1)) * 100).toFixed(2) + "%";
        sums[6] =
          isNaN(retenRate3Total) || retenRate3Total == 0 || sumArr(totalIncre3) == 0
            ? "-"
            : ((retenRate3Total / sumArr(totalIncre3)) * 100).toFixed(2) + "%";
        sums[7] =
          isNaN(retenRate7Total) || retenRate7Total == 0 || sumArr(totalIncre7) == 0
            ? "-"
            : ((retenRate7Total / sumArr(totalIncre7)) * 100).toFixed(2) + "%";
        sums[8] =
          isNaN(retenRate14Total) || retenRate14Total == 0 || sumArr(totalIncre14) == 0
            ? "-"
            : ((retenRate14Total / sumArr(totalIncre14)) * 100).toFixed(2) + "%";
        sums[9] =
          isNaN(retenRate30Total) || retenRate30Total == 0 || sumArr(totalIncre30) == 0
            ? "-"
            : ((retenRate30Total / sumArr(totalIncre30)) * 100).toFixed(2) + "%";
      }

      this.$emit("computTotalColumn", sums);
      return [];
    },
    refresh() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    sortMethod(a, b) {
      console.log(a, b);
    },
  },
  mounted() {
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.el-table {
  overflow: visible !important;
  .el-table__body-wrapper {
    height: 651px !important;
  }
}
// .el-table--border,
// .el-table--group {
//   border: none;
// }
</style>
